var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"galleryFullScreenCard"},[(_vm.element.type === 0)?_c('div',{staticClass:"cardImage",style:(("background-image: url(" + (_vm.element.image_url) + ");"))}):_c('youtube',{ref:"youtube",attrs:{"video-id":_vm.videoId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }